import { useState, useEffect } from "react";
import { buscarCaracteristicasService } from "../../../services/buscarCaracteristicasService";

export const useBuscarCaracteristicas = () => {
  const [caracteristicas, setCaracteriticas] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const buscar = async () => {
    setIsLoading(true);
    const data = await buscarCaracteristicasService();

    setCaracteriticas(data);
    setIsLoading(false);
  };

  useEffect(() => {
    buscar();
  }, []);

  return { caracteristicas, isLoading };
};
